import { render, staticRenderFns } from "./EditEcosystem.vue?vue&type=template&id=7473c3dc&scoped=true"
import script from "./EditEcosystem.vue?vue&type=script&lang=js"
export * from "./EditEcosystem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7473c3dc",
  null
  
)

export default component.exports